import { Fragment } from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "store/hook";

const WrongPage = () => {
  const { level } = useAppSelector((state) => state.global);

  let navigate = useNavigate();
  return (
    <Fragment>
      <Result 
        // 狀態 
        status="404"
        // 標題
        title="404"
        // 副標題
        subTitle="Sorry, the page you visited does not exist."
        // 操作區 點擊事件：點擊後跳轉路由至 "/" 根路徑
        extra={
          <Button
            type="primary"
            onClick={() => {
              navigate("/");
            }}
          >
            Back Home
          </Button>
        }
      />
    </Fragment>
  );
};

export default WrongPage;
